<template id="item">
    <div class="vx-row">
         <vs-divider>
             <h6>{{item.date | moment('DD. MM. YYYY')}}</h6>
        </vs-divider>
        <div class="vx-col sm:w-1/1 md:w-1/2 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Morning') |ToUppercase"
            type="number"
            v-model="item.morning"
            name="morning"
            @input="updateTotal"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.morning`)"
            >{{ errors.first(`${vvFormScope}.morning`) }}</span>
        </div>    
        <div class="vx-col sm:w-1/1 md:w-1/2 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Afternoon') |ToUppercase"
            type="number"
            v-model="item.afternoon"
            name="afternoon"
            @input="updateTotal"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.afternoon`)"
            >{{ errors.first(`${vvFormScope}.affternoon`) }}</span>
        </div>   
        <div class="vx-col sm:w-1/1 md:w-1/2 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Night') |ToUppercase"
            type="number"
            v-model="item.night"
            name="night"
            @input="updateTotal"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.night`)"
            >{{ errors.first(`${vvFormScope}.night`) }}</span>
        </div>
        <div class="vx-col sm:w-1/1 md:w-1/2 md:w-1/4 w-full">
            <vs-input
            class="w-full"
            v-validate="'required'"
            :label="$t('Together') |ToUppercase"
            type="text"
            v-model="item.together"
            name="together"
            />
            <span
            class="text-danger"
            v-show="errors.has(`${vvFormScope}.together`)"
            >{{ errors.first(`${vvFormScope}.together`) }}</span>
        </div>       
    </div>
</template>
<script>
export default {
  inject: ["$validator"],
  name: "report-item-component",
  template: "#item",
  props: {
    item: {
      type: Object
    },
    vvFormScope: {
      type: String
    },
    label: {
        type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  methods:{
    updateTotal(){
      this.item.together = Number(this.item.morning) + Number(this.item.afternoon) + Number(this.item.night);
    },
  }
};
</script>